exports.default = {
  'invite_title': '邀请朋友得积分',
  'invite_subtitle': '每次成功邀请双方均可 {points} 积分。',
  'share_web': '网页分享',
  'share_mobile': '移动端分享',
  'invite_code_label': '邀请码',
  'copy_link': '复制邀请链接',
  'invite_facebook': 'Facebook 邀请',
  'invitations': '邀请记录',
  'credits': '积分',
  'referrals': '邀请人数',
  'history_title': '邀请历史',
  'anonymous_user': '匿名用户',
  'status_pending': '待发放',
  'status_issued': '已发放',
  'status_failed': '发放失败',
  'status_limit': '邀请达到上限',
  'status_error': '异常',
  'bind_title': '填写邀请码',
  'bind_subtitle': '输入邀请码即可获得奖励积分。',
  'bind_placeholder': '请输入邀请码',
  'bind_btn': '绑定邀请码',
  'bind_code_required': '邀请码不能为空',
  'bind_success': '邀请码绑定成功！',
  'bind_failed': '绑定邀请码失败，请重试',
  'bind_already_bound': '已绑定邀请码，不能重复绑定',
  'bind_already_bound_user': '已绑定用户邀请码，不能重复绑定',
  'bind_already_bound_channel': '已绑定渠道邀请码，不能重复绑定',
  'no_records': '暂无记录',
  'share_text': 'PAITEAMS 邀请你注册领积分！快来加入吧！'
}
